import httpManager from "@/app/shared/utils/httpManager";

export async function downloadTemplateEmail(data) {
  const body = data;
  const url = "/strategies/email/download-template/";
  const response = await httpManager.post(url, body, { blob: true });
  return response.data;
}
